// extracted by mini-css-extract-plugin
export default {"root":"classes_root__ncWnj","backdrop":"classes_backdrop__9OtLO","content":"classes_content__TABVN","poster":"classes_poster__meGPW","close-button":"classes_close-button__bRs3n"};